function UserDashboard(){

return(

<div className="min-h-screen p-10">

<h1 className="text-3xl font-bold mb-6">
User Dashboard
</h1>

<p>Welcome to your dashboard.</p>

</div>

);

}

export default UserDashboard;
